<script setup>
import { computed } from 'vue'

import NotificationCounter from './NotificationCounter.vue'

const props = defineProps({
  counters: { type: Object, default: undefined }
})
const hasCounters = computed(() => {
  return (
    props.counters?.primary ||
    props.counters?.secondary ||
    props.counters?.tertiary
  )
})
const notifications = computed(() => {
  if (!hasCounters.value) return []

  return Object.keys(props.counters).map(key => {
    return {
      variant: key,
      value: props.counters[key]
    }
  })
})
</script>

<template>
  <ul v-if="hasCounters" class="notifications-container">
    <NotificationCounter
      v-for="notification in notifications"
      :key="notification.variant"
      :variant="notification.variant"
      :value="notification.value"
    />
  </ul>
</template>

<style lang="scss" scoped>
.notifications-container {
  list-style: none;
  white-space: nowrap;
  padding: 0;
}
</style>
